import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';

class CourseListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      courses: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
    });
  }

  init = action(() => {
    this.courses = [];
    this.form.reset();
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/courses?expand=academicPlan&expand=distributor',
        apiVersion: 'v2',
        query: {
          ...this.form.getValues(),
          page: this.pagination.current,
          size: this.pagination.pageSize,
          orderDirection: 'ascend',
          orderBy: 'order',
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.courses = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.courses = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });

  handleChange = action((pagination) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.load();
  });

  handleRemove = action((course) => {
    ConfirmationDialogService.show(
      'Delete Course',
      `You are about to delete the Course "${course.name}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/courses/${course.id}`,
            apiVersion: 'v2',
            method: 'delete',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Course "${course.name}" deleted successfully.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const courseListService = new CourseListService();

export default courseListService;
